<template>
  <div>
      <el-form ref="forms" label-width="100px" class="forms-lines">
        <el-form-item label="上传封面">
                <el-upload class="avatar-uploader" action="admin/ShopAttachments/image"  ref="upload"
                :headers="{ token:$store.state.user.token }" :data="{ module:'goods' }" 
                :file-list="fileList" :on-success="uploadSuccess" :on-remove="uploadRmove"
                list-type="picture-card">
                <i class="el-icon-plus"></i>
        </el-upload>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" size="small" @click="submit">立即提交</el-button>
             <el-button type="primary" size="small">重置</el-button>
        </el-form-item>
      </el-form>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
export default {
    data() {
        return {
            mapListed:[],
            fileList:[],
        }
    },
      computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted(){

        },
        methods:{
            submit(){

            },
              // 
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListed=fileList
            },
            uploadRmove(file, fileList) {
                this.mapListed=fileList
            },
        }
}
</script>

<style>

</style>